<template>
  <div class="container">
    <div class="personal">
      <div class="personal-tab">
        <div :class="show==index?'per-tab2':'per-tab'" v-for="(item,index) in personalList" @click="showTab(item,index)"
          :key="index">{{item.name}}</div>
      </div>
      <div class="hr"></div>
      <div class="personal-detail" v-if="show==0">
        <div class="userImg">
          <img class="user-img" src="../../../static/image/userinfo/lion.png" alt @click="selectFile2()" v-if="!imageUrl2"/>
          <img :src="headPicture" alt="" v-else class="user-img">
          <img class="photo" src="../../../static/image/userinfo/camera.svg" alt @click="selectFile2()"/>
          <input type="file" id="fileName" @change="uploading($event)"  accept="image/png,image/jpg" style="display: none" />
        </div>
        <div class="user-info">
          <div class="user-tr">
            <div class="phone">用户名</div>
            <div class="phone">{{userName}}</div>
            <div class="phone" @click="userNameChange()">修改</div>
          </div>
          <div class="user-tr">
            <div class="phone">手机号</div>
            <div class="phone">{{phones}}</div>
            <div class="phone" @click="phoneChange()">修改</div>
          </div>
          <div class="user-tr">
            <div class="phone">登录密码</div>
            <div class="phone">********</div>
            <div class="phone" @click="passwordChange()">修改</div>
          </div>
          <div class="user-tr">
            <div class="phone">通讯地址</div>
            <div class="phone">{{address}}</div>
            <div class="phone" @click="addressChange()">修改</div>
          </div>
          <div class="user-tr">
            <div class="phone">银行卡</div>
            <div class="phone">{{bankNumber}}</div>
            <div class="phone" @click="bankChange()">修改</div>
          </div>
          <div class="user-tr">
            <el-button type="warning" size="mini" round style="width:50%;margin-left: 25%;margin-top: 40px;" @click="logout">退出登录</el-button>
          </div>

        </div>
      </div>
      <!-- 其他信息 -->
      <div class="other-info" v-if="show==1">
        <div>
          <span>身份</span>
          <el-select v-model="identity" placeholder="请选择">
            <el-option v-for="item in options" size="mini" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="other">
          <span v-if="identity!=2"><span style="color: red;margin-right: 0" v-show="identity == 3">*</span>公司名称</span>
          <span v-if="identity==2">学校名称</span>
          <el-input v-model="company" placeholder="请输入您的公司名称" style="width: 300px;" v-if="identity!=2"></el-input>
          <el-input v-model="company" placeholder="请输入您的学校名称" style="width: 300px;" v-if="identity==2"></el-input>
        </div>
       <!-- <div class="other">
          <span>工作经验</span>
          <el-input v-model="experience" placeholder="请输入您的工作经验" style="width: 300px;"></el-input>
        </div> -->
        <div>
          <p><span style="color: red;margin-right: 0">*</span>自我描述</p>
          <el-input type="textarea" v-model="describe" placeholder="请输入个人介绍" style="width: 460px;"></el-input>
        </div>
        <div>
          <p>获奖证书</p>
          <p>

            <input type="file" id="fileName" @change="uploading($event)"  accept="image/png,image/jpg" style="display: none" />
            <div class="pic" @click="selectFile()" v-if="!imageUrl">
               <img class="user-img2" src="../../../static/image/coverWork/upload.png" alt />
            </div>
            <div v-if="imageUrl" @click="selectFile()">
               <img :src="baseImgUrl+'/'+imageUrl" alt=""  class="user-img3">
            </div>
            <span @click="selectFile()">点击上传您的获奖证书扫描件</span>

          </p>
        </div>
        <button @click="goSubmit">提交</button>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="494px" :before-close="handleClose">
      <!-- 手机号 -->
      <div v-if="isphone==true" class="phone">
        <div>
          <p>新手机号</p>
          <el-input  placeholder="请输入新手机号" maxlength="11" v-model="phone" size="medium" style="width: 200px;" @change="blurphone()"></el-input>
          <button  style="width: 100px;" v-if="codeSuccess">{{timeCount}}s后重新发送</button>
          <button @click="sendCode()" v-else>发送验证码</button>
        </div>
        <div>
          <p>短信验证码</p>
          <el-input placeholder="请输入短信验证码" maxlength="6"  v-model="code" size="medium" style="width: 200px;"></el-input>
        </div>
      </div>
      <!-- 密码 -->
      <div v-if="ispassword==true" class="password">
        <div v-if="!isNewUser">
          <p>旧密码</p>
          <el-input placeholder="请输入旧密码" maxlength="8" show-password size="medium" style="width: 300px;" v-model="password"></el-input>
        </div>
        <div>
          <p>新密码</p>
          <el-input placeholder="请输入新密码" maxlength="8" show-password size="medium" style="width: 300px;" v-model="newPassword"></el-input>
        </div>
        <div>
          <p>确认密码</p>
          <el-input placeholder="请确认密码" maxlength="8" show-password size="medium" style="width: 300px;" v-model="newPassword2"></el-input>
        </div>
      </div>
      <!-- 地址 -->
      <div v-if="isaddress==true" class="address">
        <div>
          <p>收货人</p>
          <el-input placeholder="请输入收货人姓名" v-model="name" size="medium" style="width: 300px;"></el-input>
        </div>
        <div>
          <p>手机号码</p>
          <el-input placeholder="请输入收货人手机号码" v-model="phonenumber" size="medium" style="width: 300px;" @change="blurphone2()"></el-input>
        </div>
        <div>
          <p>所在地区</p>
          <el-select v-model="provinceId" clearable size="mini" placeholder="请选择" style="width: 113px;" @change="getCitytree2">
            <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="cityId" clearable size="mini" placeholder="请选择" style="width: 113px;" @change="getCitytree3">
            <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="countyId" size="mini" clearable placeholder="请选择" style="width: 113px;">
            <el-option v-for="item in county" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <p>详细地址</p>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" style="width: 379px;"
            v-model="house">
          </el-input>
        </div>
      </div>
      <!-- 用户名 -->
      <div v-if="isUserName==true" class="phone">
        <div>
          <p>新用户名</p>
          <el-input  placeholder="请输入新用户名" v-model="userName1" size="medium" style="width: 200px;" ></el-input>
        </div>
      </div>
      <!-- 银行卡 -->
      <div v-if="isBank==true" class="bank">
        <div>
          <p>新银行卡卡号</p>
          <el-input  placeholder="请输入新银行卡卡号" v-model="bankNumber1" size="medium" style="width: 300px;"></el-input>
        </div>
        <div>
          <p>开户银行</p>
          <el-input  placeholder="请输入开户银行" v-model="bankName" size="medium" style="width: 300px;"></el-input>
        </div>
        <div>
          <p>开户省市</p>
          <el-input  placeholder="请输入开户省市" v-model="bankBranch" size="medium" style="width: 300px;"></el-input>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancal">取 消</el-button>
        <el-button @click="course">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import config from "../../api/config";
  import manage from "../../api/manage";
  export default {
    name: "personalInformation",
    data() {
      return {
        isTrue:false,  //判断是账号信息还说其他信息得图片上传
        headPicture:'',  //头像完整地址  有从微信直接获取的完整地址或不完整的
        timeCount: 60,   //验证码60秒
        codeSuccess:false,   //是否显示多少秒后发送
        // 地址修改
         name:'',  //收货人
         id: 0,
         phonenumber:'',  //手机号码
         house:'',   //详细地址
         province:'',
         city:'',
         county:'',
         provinceId:'',
         cityId:'',
         countyId:'',
         userName:'',//用户名
         userName1:'',//新用户名
         bankName:'',
         bankBranch:'',
         bankNumber:'',
         bankNumber1:'', //新银行卡
        // 结束
        baseImgUrl:config.baseImgUrl,   //拼接地址
        imageUrl:'', //图片地址
        imageUrl2:'', //头像图片地址
        address:'',  //通讯地址计划
        userInfo:{},  //用户信息
        phone:'',//手机号
        phones:'',  // 显示的不完整手机号
        phone2:'',  //修改密码得手机号码
        code:'',  //验证码
        // getcode:'',  //系统给的验证码
        password:'',  //原密码
        newPassword:'',  //新密码
        newPassword2:'',  //确认密码
        title: '',
        dialogVisible: false, //弹窗
        isphone: false,
        ispassword: false,
        isNewUser:false,
        isaddress: false,
        isUserName:false,
        isBank:false,
        options: [{
          value: '1',
          label: '设计师'
        }, {
          value: '2',
          label: '学生'
        }, {
          value: '3',
          label: '设计公司/工作室'
        }],
        identity: '', //身份
        company: '', //公司
        // experience: '', //工作经验
        describe: '', //自我描述
        personalList: [{
            name: "账户信息",
            index: 0,
          },
          {
            name: "其他信息",
            index: 1,
          },
        ],
        show: 0,
        // baseUrl:baseUrl,
      };
    },
    created() {
       // 获取存的用户信息
         this.getDetails()
         // 省市区
         this.getCitytree()
         // this.getCitytree2()
         // this.getCitytree3()
    },
    methods: {
      async logout(){
        this.$confirm('确认退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // localStorage.setItem("token", "");
		  localStorage.removeItem("token")
		  sessionStorage.removeItem('returnUrl')
          localStorage.setItem("userInfo", {});
          localStorage.setItem("visit", '0');
          this.$router.push({ path: "/login/login" });
        }).catch(() => {
        });

      },
      async getOtherInfo(){  //其他信息头像修改
        let data = {
           headPicture:this.imageUrl2
        }
        try {
          const res = await this.$http.getOtherInfo(data)
          console.log(res)
          if (res.code == 200) {
               this.$router.go(0);
          } else {
            this.$message(res.message);
          }
        } catch (e) {
           throw e
        }
      },
      async getCitytree(){  //省
        try {
          const res = await this.$http.getCitytree()
          console.log(res)
          if (res.code == 200) {
              this.province = res.result.result;
              // this.getCitytree2(this.provinceId)
          } else {
            this.$message(res.message);
          }
        } catch (e) {
           throw e
        }
      },
      async getCitytree2(value){  //市
          console.log(value)
          this.cityId = '';
          this.countyId = ''
          let id = value;
        try {
          const res = await this.$http.getCitytree(id)
          console.log(res)
          if (res.code == 200) {
              this.city = res.result.result;
              // this.getCitytree3(this.cityId)
          } else {
            this.$message(res.message);
          }
        } catch (e) {
           throw e
        }
      },
      async getCitytree3(value){  //区
        this.countyId = ''
        let id = value;
        try {
          const res = await this.$http.getCitytree(id)
          console.log(res)
          if (res.code == 200) {
              this.county = res.result.result;
          } else {
            this.$message(res.message);
          }
        } catch (e) {
           throw e
        }
      },
      selectFile() {  //其他信息通过点击触发上传图片事件
        this.isTrue = false;
        document.getElementById("fileName").click();
      },
      selectFile2() {  //账户信息通过点击触发上传图片事件
        this.isTrue = true;
        document.getElementById("fileName").click();
      },
      async uploading(event) { //上传图片
        console.log(event)
        let file = event.target.files[0];
        let fileName = file.name;
        let fileSize = file.size;
        if (fileName.indexOf(".png") == -1) {
          this.$message.error('文件格式必须为png！', 2000)
          return false;
        }
        if (fileName.length > 50) {
          this.$message.error('文件名称过长，请求改！', 2000)
          return false;
        }
        if (fileSize > 1024 * 1024 * 2) {
          this.$message.error('上传文件大小不能超过2M！', 2000)
          return false;
        }
        let data = {
          biz: 'temp',
          file: fileName
        }

        let formData = new FormData()
        formData.append('fileName', fileName)
        formData.append('file', file)
        console.log(formData)
        let res = await manage.uploadAction('/api/common/upload', formData)
        if (res.data.code == 200) {
          this.$message.success('上传成功', 1000)
          if(!this.isTrue){
            this.imageUrl = res.data.message;

          }else{
            this.imageUrl2 = res.data.message;
            this.getOtherInfo()
            // this.$emit('getDetail')
          }
          console.log(this.imageUrl,this.baseImgUrl,res.data.message)
        } else {
          this.$message.error(res.message, 1000)
        }
      },
      blurphone(){  //手机号验证
        console.log(11111)
        let reg =  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if(!reg.test(this.phone)){
            this.phone = ''

        }
      },
      blurphone2(){  //手机号验证
        console.log(11111)
        let reg =  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if(!reg.test(this.phonenumber)){
            this.phonenumber = ''
        }
      },
      async sendCode(){  //手机号验证码
        console.log(this.phone)

          try {

            let data = {
               phone:this.phone,
               smsMode:5
            }
            if(this.phone.length==0){
              this.$message.error("手机号码格式不正确")
            }else{
              const res = await this.$http.getDesignerSms(data)
              console.log(res)
              if (res.code == 200) {
                this.codeSuccess = true
                this.timeCount = 60
                let timer = setInterval(() => {
                            if (this.timeCount <= 0) {
                                clearInterval(timer);
                                 this.codeSuccess = false
                                 this.timeCount=60
                            } else {
                                let count = this.timeCount-1;
                                this.timeCount= count
                            }
                 }, 1000)
              } else {
                this.$message.error(res.message);
              }
            }

          } catch (e) {
             throw e
          }
      },
      cancal() {
        this.phone=''
        this.code=''
        this.password =''
        this.newPassword= ''
        this.newPassword2=''
        // this.userName = ''
        // this.bankName = ''
        // this.bankNumber = ''
        // this.bankBranch = ''
        // this.name = ''
        // this.phonenumber = ''
        // this.house =''
        // this.provinceId =''
        // this.cityId =''
        // this.countyId =''
        // 关闭弹窗
        this.dialogVisible = false;
        this.isphone = false;
        this.ispassword = false;
        this.isaddress = false;
        this.isUserName = false;
        this.isBank = false;
      },
      async course() {   // 账户信息3个弹窗的确定按钮
        if(this.isphone){
          try {
            if(this.phone==''){
              this.$message.error('请输入新手机号码');
              return false
            }
            if(this.code==''){
              this.$message.error('请输入短信验证码');
              return false
            }
            let data = {
               phone:this.phone,
               captcha:this.code
            }
            if(this.phone!=''&&this.code!=''){
              const res = await this.$http.updatePhone2(data)
              console.log(res)
              if (res.code == 200) {
                this.phone=''
                this.code=''
                this.$message.success('手机号码修改成功');
                this.getDetails()
                this.dialogVisible = false;
                this.isphone = false;
                this.ispassword = false;
                this.isaddress = false;
              } else {
                this.$message.error(res.message);
              }
            }
          } catch (e) {
             throw e
          }
        }
        else if(this.isUserName) {
          try {
            if(this.userName1==''){
              this.$message.error('请输入新用户名');
              return false
            }
            let data = {
              name:this.userName1
              // id: this.id
            }
            console.log(data.id);
            if(this.userName1!==''){
              const res = await this.$http.updateName(data)
              console.log(res)
              if (res.code == 200) {
                this.phone=''
                this.code=''
                this.$message.success('用户名修改成功');
                this.getDetails()
                 this.$router.go(0);
                this.dialogVisible = false;
                this.isphone = false;
                this.ispassword = false;
                this.isaddress = false;
                this.isUserName = false;
              } else {
                this.$message.error(res.message);
              }
            }
          } catch(e) {
            throw e
          }
        }
        else if(this.isBank) {
          try {
            if(this.bankNumber==''){
              this.$message.error('请输入银行卡卡号');
              return false
            }
            if(this.bankName==''){
              this.$message.error('请输入开户银行')
            }
            if(this.bankBranch==''){
              this.$message.error('请输入开户省市')
            }
            let data = {
              accountName:this.name,
              bankBranch:this.bankBranch,
              bankName:this.bankName,
              bankNumber:this.bankNumber1
              // id: this.id
            }
            // console.log(data.id);
            if(this.bankNumber1!=='' && this.bankBranch!=='' && this.bankName!==''){
              const res = await this.$http.getOtherInfo(data)
              console.log(res)
              if (res.code == 200) {
                this.phone=''
                this.code=''
                this.$message.success('银行卡修改成功');
                this.getDetails()
                this.dialogVisible = false;
                this.isphone = false;
                this.ispassword = false;
                this.isaddress = false;
                this.isUserName = false;
                this.isBank = false;
              } else {
                this.$message.error(res.message);
              }
            }
          } catch(e) {
            throw e
          }
        }
        else if(this.ispassword){
          try {
               if((!/^[a-zA-Z0-9]{8,8}$/.test(this.password)) && !this.isNewUser){
                      this.$message.error('密码请输入8位数字或字母');
                      return false;
                }
                if(!/^[a-zA-Z0-9]{8,8}$/.test(this.newPassword) ){
                      this.$message.error('新密码请输入8位数字或字母');
                      return false;
                }
                if(!/^[a-zA-Z0-9]{8,8}$/.test(this.newPassword2)){
                      this.$message.error('确认密码请输入8位数字或字母');
                      return false;
                }
                if(this.newPassword!=this.newPassword2){
                      this.$message.error('两次密码请保持一致');
                      return false;
                }
            let data = {
               // captcha:this.code,
               phone:this.phone2,
               password:this.password,
               newPassword1:this.newPassword,
               newPassword2:this.newPassword2,
            }
            if((this.password!='' || this.isNewUser) && this.newPassword1!='' && this.newPassword2!=''){
                const res = await this.$http.updateApiPassword(data)
                console.log(res)
                if (res.code == 200) {
                  this.getDetails()
                  if(this.isNewUser){
                    this.$message.success('设置密码成功');
                  }else{
                    this.$message.success('修改密码成功');
                  }
                  this.isNewUser = false
                  this.password =''
                  this.newPassword= ''
                  this.newPassword2=''
                  this.dialogVisible = false;
                  this.isphone = false;
                  this.ispassword = false;
                  this.isaddress = false;
                } else {
                  this.$message(res.message);
                }

            }
          }catch (e) {
             throw e
          }
        }else{
          try {
            if(this.name=='' || this.name==null){
              this.$message.error('请输入收货人');
              return false;
            }
            if(this.phonenumber=='' || this.phonenumber==null){
              this.$message.error('请输入收货人手机号码');
              return false;
            }
            if(this.provinceId=='' || this.provinceId==null || this.cityId=='' || this.cityId==null|| this.countyId=='' || this.countyId==null){
              this.$message.error('请填写所在地区');
              return false;
            }
            if(this.house=='' || this.house==null){
              this.$message.error('请输入详情地址');
              return false;
            }
            let data = {
              consigneeName:this.name,
              consigneePhone:this.phonenumber,
              addressDetail:this.house,
              province:this.provinceId,
              city:this.cityId,
              county:this.countyId,
            }
            if(this.name!=''&&this.phonenumber!=''&&this.provinceId!=''&&this.cityId!=''&&this.countyId!=''&&this.house!=''){
              const res = await this.$http.getAddress(data)
              console.log(res)
              if (res.code == 200) {
                 this.getDetails()
                this.$message.success('通讯地址修改成功');

                // this.name = ''
                // this.phonenumber = ''
                // this.house =''
                // this.provinceId =''
                // this.cityId =''
                // this.countyId =''
                this.dialogVisible = false;
                this.isphone = false;
                this.ispassword = false;
                this.isaddress = false;
              } else {
                this.$message(res.message);
              }
            }


          } catch (e) {
             throw e
          }
        }

      },
      userNameChange() {
        this.dialogVisible = true;
        this.title = '修改用户名';
        this.userName1 = this.userName
        this.isUserName = true;
      },
      // 手机号修改
      phoneChange() {
        this.dialogVisible = true;
        this.title = '修改手机号'
        this.isphone = true;
      },
      passwordChange() {
        this.dialogVisible = true;
        if(this.userInfo.password!=null){
           this.title = '修改密码'
           this.isNewUser = false
        }else{
          this.title = '设置密码'
          this.isNewUser = true
        }
        this.ispassword = true;
      },
      addressChange() {
        this.dialogVisible = true;
        this.title = '通讯地址'
        this.isaddress = true;
      },
      bankChange() {
        this.dialogVisible = true;
        this.title = '银行卡'
        this.bankNumber1=this.bankNumber
        this.isBank = true;
      },
      showTab(item, index) {
        this.show = index;
      },
      handleClose() {
        // 清空数据
        this.phone=''
        this.code=''
        this.password =''
        this.newPassword= ''
        this.newPassword2=''
        // this.userName = ''
        // this.bankName = ''
        // this.bankNumber = ''
        // this.bankBranch = ''
        // this.name = ''
        // this.phonenumber = ''
        // this.house =''
        // this.provinceId =''
        // this.cityId =''
        // this.countyId =''
        // 关闭弹窗
        this.dialogVisible = false;
        this.isphone = false;
        this.ispassword = false;
        this.isaddress = false;
        this.isUserName = false;
        this.isBank = false;
      },
      async goSubmit() {   //其他信息修改确定按钮
         try {
           let data = {
              identity:this.identity,
              belong:this.company,
              detail:this.describe,
              certificate:this.imageUrl,
           }
           if((this.identity == 3 && !this.company) || !this.describe){
             this.$message("请填写必填内容");
           }else{
             const res = await this.$http.getOtherInfo(data)
             console.log(res)
             if (res.code == 200) {
               // this.identity = '',
               // this.company= '',
               // this.describe= '',
               // this.imageUrl= '',
               this.$message.success('修改成功')
             } else {
               this.$message(res.message);
             }
           }

         } catch (e) {
            throw e
         }
      },
      async getDetails(){   //获取保存数据
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
          try {
            const res = await this.$http.getDetails(userInfo.id)
            this.id = userInfo.id
            console.log(userInfo.id);
            console.log(res);
            //res.result.name
            if (res.code == 200) {
                this.phones = res.result.phone.substr(0,2) + "*****" + res.result.phone.substr(7,11);
                // (res.result.provinceCityCounty+res.result.addressDetail)==null?'':
                this.address = res.result.provinceCityCounty+res.result.addressDetail;
                if(this.address==='null'){
                  this.address=''
                }else{
                  this.address = this.address
                }
                this.imageUrl2 = res.result.headPicture
                // this.headPicture = this.imageUrl2.indexOf('http')>-1? this.imageUrl2:this.baseImgUrl+ this.imageUrl2;
                this.headPicture = this.imageUrl2?this.imageUrl2.indexOf('http')>-1? this.imageUrl2:this.baseImgUrl+ this.imageUrl2:"";
                this.phone2 = res.result.phone;

                // 通讯地址回显

                this.name =  res.result.consigneeName,
                this.bankName = res.result.bankName,
                this.bankBranch = res.result.bankBranch,
                this.bankNumber = res.result.bankNumber,
                this.userName = res.result.name,
                this.phonenumber=  res.result.consigneePhone,
                this.house = res.result.addressDetail,
                this.provinceId = res.result.province,
                this.getCitytree2(this.provinceId)
                this.cityId  = res.result.city,
                this.getCitytree3(this.cityId)
                this.countyId =  res.result.county,
                // 其他信息修改回显
                this.identity = res.result.identity,
                this.company= res.result.belong,
                this.describe= res.result.detail,
                this.imageUrl= res.result.certificate,
                this.userInfo = res.result
                console.log(res.result.gradeValue,res.result.upgradeValue,this.total)
            } else {
              this.$message(res.message);
            }
          } catch (e) {

            throw e
          }
        },
    },
  };
</script>


<style scoped>
  .pic{
    width: 79px;
    height: 79px;
    background: #F7F7F7;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .user-img2{
    width: 29px;
    height: 26px;
  }
  .user-img3{
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }
  .address>div {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999999;
    margin-bottom: 10px;
  }
  .address>div:nth-of-type(1)>p {
    margin-right: 32px;
  }
  /* .address>div>p::before{
    content:"*";
    color:red;
    font-weight: bold;
  } */
  .address>div:nth-of-type(2)>p {
     margin-right: 20px;
  }
  .address>div:nth-of-type(3) {
    justify-content: space-between;
  }

  .address>div:nth-of-type(4)>p {
    margin-right: 20px;
  }

  .password>div {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #707070;
    justify-content: space-between;
  }

  .password>div>p {
    margin-right: 37px;

  }

  .password>div:nth-of-type(3)>p {
    margin-right: 21px;
  }

  .dialog-footer>button:nth-of-type(1) {
    background-color: #FFEDD5;
    color: #DDA254;
    font-size: 12px;
  }

  .dialog-footer>button:nth-of-type(2) {
    background-color: #DDA254;
    color: #FFFFFF;
    font-size: 12px;
  }

  .phone>div:nth-of-type(1) {
    display: flex;
    align-items: center;
  }

  .phone>div:nth-of-type(1)>p {
    margin-right: 48px;
  }

  .phone>div:nth-of-type(1)>button {
    margin-left: 16px;
    width: 80px;
    height: 26px;
    background: #FFFFFF;
    border: 1px solid #DFB876;
    opacity: 1;
    border-radius: 5px;
    font-size: 12px;
    color: #DFB876;
  }

  .phone>div:nth-of-type(2)>p {
    margin-right: 34px;
  }

  .phone>div:nth-of-type(2) {
    display: flex;
    align-items: center;

  }

  .other>>>.el-input__inner {
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #9E9E9E;
  }
  /* .other::before{
    content: '*';
    color: red;
  } */
  .other-info {
    padding: 37px 0px 0 45px;
  }

  .other {
    display: flex;
    align-items: center;
  }

  .other-info>div {
    margin-bottom: 27px;
  }

  .other-info>div>span {
    font-size: 14px;
    font-weight: bold;
    color: #3A3A3A;
  }

  .other-info>div>p:nth-of-type(1) {
    font-size: 14px;
    font-weight: bold;
    color: #3A3A3A;
  }

  .other-info>div:nth-of-type(1) span {
    margin-right: 110px;
    font-weight: bold;
  }

  .other-info>.other:nth-of-type(2) span {
    margin-right: 60px;
  }

  .other-info>.other:nth-of-type(3) span {
    margin-right: 90px;
  }

  .container {
    width: 900px;
    /* height: 576px; */
    background-color: #FFFFFF;
  }

  .personal {
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #C7C7C7;
  }

  .personal-tab {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #3A3A3A;
  }

  .per-tab {
    margin: 0 45px;
    height: 100%;
    line-height: 64px;
  }

  .per-tab2 {
    margin: 0 45px;
    border-bottom: 2px solid #707070;
    height: 100%;
    line-height: 64px;
    font-weight: bold;
  }

  .user-info {
    padding: 0 76px 0 45px;
    line-height: 50px;
  }

  .user-tr {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: #3A3A3A;
  }

  .user-tr>div:last-of-type {
    color: #658FFF;
  }

  .userImg {
    padding: 30px 0 60px;
    text-align: center;
    position: relative;
  }

  .userImg>img:nth-of-type(1) {
    width: 99px;
    height: 99px;
    border-radius: 50%;
  }
  .userImg>img:nth-of-type(2) {
    position: absolute;
    top: 100px;
    left: 472px;
  }
  .other-info button {
    width: 115px;
    height: 39px;
    background-color: #DFB876;
    border-radius: 20px;
    font-size: 15px;
    color: #FFFFFF;
    border: none;
    outline: none;
  }
  .bank>div {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #707070;
    justify-content: space-between;
  }

  .bank>div>p {
    margin-right: 37px;

  }

  .bank>div:nth-of-type(3)>p {
    margin-right: 21px;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalInformation/personalInformation.vue